module.exports = __webpack_public_path__ + "static/media/1_EN.9b32b699.mp3";